import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js'

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : ''
}

export default Vue.extend({
  components: {
    'settings-container': SettingsContainer
  },

  props: {
    templatesData: {
      type: Object,
      required: true
    }
  },

  computed: {
    defaultTemplates() {
      return this.templatesData.default_templates || []
    },

    customTemplates() {
      return this.templatesData.custom_templates || []
    },

    paths() {
      return this.templatesData.paths || {}
    },

    authenticityToken() {
      return csrfToken()
    }
  },

  methods: {
    templateIcon(template) {
      if (template.type === 'Template::Page') return 'fa-file-text-o'
      if (template.type === 'Template::Category') return 'fa-book'
      if (template.type === 'Template::CmsSearch') return 'fa-search'
      return 'fa-code'
    },

    confirmDelete(event) {
      if (!window.confirm('确定删除')) event.preventDefault()
    }
  },

  template: `
    <settings-container active-tab="templates">
      <template slot="content">
        <div class="templates-settings">
          <div class="templates-header panel-card">
            <div>
              <div class="templates-kicker">模板设置</div>
              <h1>所有模板</h1>
              <p>管理分类、文章和搜索页面模板。</p>
            </div>
            <div class="templates-header-actions">
              <a :href="paths.snippets" class="btn btn-default btn-small outlined">管理片段</a>
              <a :href="paths.menu" class="btn btn-default btn-small outlined">修改菜单</a>
              <a :href="paths.new" class="btn btn-primary btn-small">
                <i class="slp-plus"></i>
                添加自定义模板
              </a>
            </div>
          </div>

          <div class="panel-card templates-card">
            <div class="panel-card-head">
              <span class="panel-card-title">默认模板</span>
            </div>
            <div class="panel-card-body">
              <div class="templates-list">
                <a v-for="template in defaultTemplates"
                   :key="template.id"
                   :href="template.paths.show"
                   class="template-list-item">
                  <span class="template-icon"><i :class="'fa ' + templateIcon(template)"></i></span>
                  <span class="template-list-copy">
                    <span class="template-name">{{ template.name }}</span>
                    <span class="template-meta">{{ template.human_type }}</span>
                  </span>
                  <span class="template-action">编辑</span>
                </a>
              </div>
            </div>
          </div>

          <div class="panel-card templates-card">
            <div class="panel-card-head">
              <span class="panel-card-title">自定义模板</span>
              <a :href="paths.new" class="btn icon-btn link-btn squared" title="添加自定义模板">
                <i class="fa fa-plus"></i>
              </a>
            </div>
            <div class="panel-card-body">
              <div v-if="customTemplates.length === 0" class="templates-empty">暂无自定义模板</div>
              <div v-else class="templates-list">
                <div v-for="template in customTemplates"
                     :key="template.id"
                     class="template-list-item">
                  <span class="template-icon"><i :class="'fa ' + templateIcon(template)"></i></span>
                  <a :href="template.paths.show" class="template-list-copy">
                    <span class="template-name">{{ template.name }}</span>
                    <span class="template-meta">{{ template.human_type }}</span>
                  </a>
                  <div class="template-actions">
                    <a :href="template.paths.show" class="btn icon-btn link-btn squared" title="编辑">
                      <i class="fa fa-pencil"></i>
                    </a>
                    <form :action="template.paths.destroy"
                          method="post"
                          class="inline-template-form"
                          @submit="confirmDelete">
                      <input type="hidden" name="authenticity_token" :value="authenticityToken" />
                      <input type="hidden" name="_method" value="delete" />
                      <button type="submit" class="btn icon-btn link-btn squared" title="删除">
                        <i class="fa fa-trash"></i>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </settings-container>
  `
})
